import { useEffect, useRef, useState } from "react";
import { Box, TextField } from "@mui/material";

function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(value || "");
}

function htmlToText(html) {
  if (!html) {
    return "";
  }
  if (!looksLikeHtml(html)) {
    return html.replace(/\r\n/g, "\n");
  }

  return html
    .replace(/\r\n/g, "\n")
    .replace(/<li\b[^>]*data-list=["']bullet["'][^>]*>/gi, "\n- ")
    .replace(/<ul\b[^>]*>([\s\S]*?)<\/ul>/gi, (_, inner) =>
      inner.replace(/<li\b[^>]*>/gi, "\n- ")
    )
    .replace(/<li\b[^>]*>/gi, "\n")
    .replace(/<br\s*\/?>/gi, "\n")
    .replace(/<\/(p|div|h[1-6]|ul|ol|blockquote)>/gi, "\n")
    .replace(/<[^>]+>/g, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/g, "&")
    .replace(/&lt;/g, "<")
    .replace(/&gt;/g, ">")
    .replace(/&quot;/g, '"')
    .replace(/\n{3,}/g, "\n\n")
    .replace(/^\n+|\n+$/g, "");
}

function escapeHtml(text) {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
}

function textToHtml(text) {
  if (!text) {
    return "";
  }
  return escapeHtml(text).replace(/\n/g, "<br>");
}

export default function QuillRTE(props) {
  const [text, setText] = useState(() => htmlToText(props.value));
  const lastEmittedHtml = useRef(textToHtml(htmlToText(props.value)));

  useEffect(() => {
    if (props.value === lastEmittedHtml.current) {
      return;
    }
    setText(htmlToText(props.value));
    lastEmittedHtml.current = textToHtml(htmlToText(props.value));
  }, [props.value]);

  return (
    <Box>
      <TextField
        fullWidth
        multiline
        minRows={4}
        value={text}
        onChange={(e) => {
          const next = e.target.value;
          const html = textToHtml(next);
          setText(next);
          lastEmittedHtml.current = html;
          props.onChange(html);
        }}
        placeholder={props.placeholder || "Enter text here.."}
        helperText={props.helperText || ""}
      />
    </Box>
  );
}
